import {
	faFacebookF,
	faInstagram,
	faWhatsapp,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
	faArrowLeft,
	faArrowRight,
	faAward,
	faBars,
	faBed,
	faBolt,
	faBookQuran,
	faBuilding,
	faBus,
	faCalendarDays,
	faCamera,
	faCertificate,
	faCheck,
	faChevronLeft,
	faChevronRight,
	faCircleCheck,
	faClock,
	faComments,
	faEnvelope,
	faGift,
	faGlobe,
	faHandsPraying,
	faHandshake,
	faHeadset,
	faHeart,
	faHotel,
	faIdCard,
	faImage,
	faImages,
	faKaaba,
	faLocationDot,
	faMagnifyingGlass,
	faMapLocationDot,
	faMedal,
	faMoneyBillWave,
	faMosque,
	faNewspaper,
	faPassport,
	faPeopleGroup,
	faPhone,
	faPlane,
	faPlaneDeparture,
	faRoute,
	faShieldHalved,
	faStar,
	faSuitcaseRolling,
	faTag,
	faTags,
	faUsers,
	faUserTie,
	faUtensils,
	faVanShuttle,
	faWallet,
	faWifi,
	faXmark,
} from '@fortawesome/free-solid-svg-icons';

// Semua ikon yang dipakai landing page — diregistrasi sekali di FaIconLibrary
// agar template cukup memakai <fa-icon icon="nama" /> atau [icon]="['fab','whatsapp']".
export const APP_ICONS = [
	// solid
	faArrowLeft,
	faArrowRight,
	faAward,
	faBars,
	faBed,
	faBolt,
	faBookQuran,
	faBuilding,
	faBus,
	faCalendarDays,
	faCamera,
	faCertificate,
	faCheck,
	faChevronLeft,
	faChevronRight,
	faCircleCheck,
	faClock,
	faComments,
	faEnvelope,
	faGift,
	faGlobe,
	faHandsPraying,
	faHandshake,
	faHeadset,
	faHeart,
	faHotel,
	faIdCard,
	faImage,
	faImages,
	faKaaba,
	faLocationDot,
	faMagnifyingGlass,
	faMapLocationDot,
	faMedal,
	faMoneyBillWave,
	faMosque,
	faNewspaper,
	faPassport,
	faPeopleGroup,
	faPhone,
	faPlane,
	faPlaneDeparture,
	faRoute,
	faShieldHalved,
	faStar,
	faSuitcaseRolling,
	faTag,
	faTags,
	faUsers,
	faUserTie,
	faUtensils,
	faVanShuttle,
	faWallet,
	faWifi,
	faXmark,
	// brands
	faFacebookF,
	faInstagram,
	faWhatsapp,
	faYoutube,
];
